import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = {
  class: "body_div",
  style: {}
}
const _hoisted_3 = ["src"]

import { ref, reactive } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'moduleImageList',
  props: {
  item: { type: Object, default: "" },
},
  setup(__props) {

const yyy = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.item.coverSheet
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", null, _toDisplayString(__props.item.name), 1)
  ]))
}
}

})